import moment from 'moment/moment';
import React, { Component } from 'react';
import Select from 'react-select';
import { Modules, SERVICE_RESPONSE, decodeText } from '../libs/utils/Const';
import config from '../config';
import ApiClient from '../libs/apiClient';
const apiClient = ApiClient.getInstance();
const whsBlocked = ['099', '003', '008'];
const placeholderSearch = {
    '4': 'Artículo',
    '290': 'Recurso',
    '-18': 'Texto',
}
const formatNumber = value => {
    const num = parseFloat(value);
    if (isNaN(num)) return ''
    if (num === 0) return ''
    return num
}
const headersBody = [
    { title: "Tipo", value: true },
    { title: "N°", value: true },
    { title: "Descripción", value: true, style: { minWidth: 200 } },
    { title: "Cantidad Base", value: true },
    { title: "Ctd.Requerida", value: true },
    { title: "Consumido", value: true },
    { title: "Stock en Alm.", value: true },
    // { title: "Cod. Unidad de medida", value: true },
    { title: "Nom. Unidad de medida", value: true },
    { title: "Almacén", value: true },
    { title: "Método de emisión", value: true },
    // { title: "Cta. WIP", value: true },
    // { title: "Lote Nacional", value: true },
    { title: "CANAL", value: Modules.CostCenter },
    { title: "SEDES", value: Modules.CostCenter },
    { title: "SUCURSAL", value: Modules.CostCenter },
    { title: "NEGOCIO", value: Modules.CostCenter },
    { title: "CECO", value: Modules.CostCenter },
    { title: "", value: true },
];
const Origin = {
    'M': 'Manual',
    'R': 'MRP',
    'S': 'Orden de Venta',
    'U': 'Actualización'
}

class ContentProductionOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
        };
    }

    componentDidMount = async () => {

    }
    changeSearchItem = async (event) => {
        const { newOrderModel, refreshModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.searchItemMaterial = event.nativeEvent.target.value.trim();
        }
        refreshModel(newOrderModel);
    }
    openItems = async (type = 'head') => {
        const { openItems } = this.props
        openItems(type)
    }
    openListMaterial = async () => {
        const { openListMaterial } = this.props

        openListMaterial()
    }
    openPartner = async () => {
        const { openPartner } = this.props
        openPartner()
    }
    ChangeData = (event, key) => {
        const { newOrderModel, refreshModel, wareHouses = [] } = this.props;
        const { _user } = this.state;
        let auxKey = null;
        let value = null;
        const auxModel = { ...newOrderModel }
        if (key === 'PlannedQuantity') {
            if (isNaN(event.nativeEvent.target.value) || Number(event.nativeEvent.target.value) < 0) {
                return
            }
            let orderLines = auxModel.ProductionOrderLines.slice()
            for (let index = 0; index < orderLines.length; index++) {
                let line = orderLines[index];
                line.PlannedQuantity = event.nativeEvent.target.value * (line.BaseQuantity || 0)
            }
            auxModel.ProductionOrderLines = orderLines

        }
        if (key === 'Warehouse') {
            let orderLines = auxModel.ProductionOrderLines.slice()
            for (let index = 0; index < orderLines.length; index++) {
                let line = orderLines[index];
                line.Warehouse = event.nativeEvent.target.value
            }
            auxModel.ProductionOrderLines = orderLines
        }
        if (key === 'WarehouseH') { // Almacén cabecera
            auxKey = key;
            key = 'Warehouse';
            value = event?.value ?? event?.nativeEvent?.target?.value ?? null;
            if (value) {
                //#region Validar almacén de la linea pertenezca al de cabecera
                const U_FMB_WHS_TYPE = Number(_user?.Branch?.AccountDefault?.[0]?.U_FMB_WHS_TYPE ?? 0);
                const availableWhs = _user?.Branch?.AvailableWhs ?? [];
                const availableSet = new Set(availableWhs.map(a => a.WhsCode));
                const whsMap = new Map((wareHouses ?? []).map(w => [w.WhsCode, w]));
                const headerWhs = String(value ?? '');

                for (const line of auxModel?.ProductionOrderLines ?? []) {
                    const allowedTypes =
                        (Number(line?.ItemType ?? 4) === 4 ||
                            Number(line?.ItemType ?? 4) === 290)
                            ? ['003', '004', '099', '008']
                            : null;

                    const whs = whsMap.get(line.Warehouse);

                    if (!whs) {
                        line.Warehouse = '';
                        continue;
                    }

                    const baseCondition =
                        whs.Inactive === 'N' &&
                        (
                            !allowedTypes ||
                            allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '')
                        );

                    const warehouseValid =
                        baseCondition &&
                        (
                            U_FMB_WHS_TYPE === 3 ||
                            availableSet.has(whs.WhsCode)
                        );

                    const lineWhs = String(whs.WhsCode);

                    const first3Match = headerWhs?.substring(0, 3) === lineWhs?.substring(0, 3);
                    const first2Match = headerWhs?.substring(0, 2) === lineWhs?.substring(0, 2);

                    const prefixValid = first3Match || first2Match;

                    line.Warehouse = (warehouseValid && prefixValid)
                        ? whs.WhsCode
                        : '';
                }
                //#endregion Validar almacén de la linea pertenezca al de cabecera
            }
        }
        if (key === 'ProductionOrderStatus') {
            const value = event?.nativeEvent?.target?.value;
            auxModel.OnlyView = value === 'R' ? true : auxModel?.CurrentStatus === 'P' && value === 'P' ? false : auxModel.OnlyView;
        }

        auxModel[key] = auxKey === 'WarehouseH' ? value || null : event.nativeEvent.target.value;
        refreshModel(auxModel)
    }

    changeHeaderField = async (key, value, maxLength = null, isNumber = false) => {
        const { newOrderModel, refreshModel } = this.props;
        const auxModel = { ...newOrderModel }
        let newValue = value ?? '';

        if (isNumber) {
            newValue = newValue?.replace(/[^0-9.]/g, '');
            const parts = newValue?.split('.');
            if (parts?.length > 2) {
                newValue = parts[0] + '.' + parts?.slice(1)?.join('');
            }
        }

        if (maxLength) {
            newValue = newValue?.slice(0, maxLength);
        }

        auxModel[key] = newValue;
        await refreshModel(auxModel);
    }

    changeBlurHeaderField = async (key, value, toFixedValue = null) => {
        const { newOrderModel, refreshModel } = this.props;
        const auxModel = { ...newOrderModel }
        if (toFixedValue || toFixedValue === 0) {
            value = !value || value === '.' ? 0 : value;
            auxModel[key] = Number(value || 0)?.toFixed(toFixedValue);;
            await refreshModel(auxModel);
        }
    }

    openPersonRequest = async () => {
        const { openPersonRequest } = this.props
        openPersonRequest()
    }
    openSeries = () => {
        const { openSeries } = this.props;
        openSeries()
    }

    ChangeProject = event => {
        const { newOrderModel, refreshModel } = this.props;
        if (event && event.value !== undefined) {
            newOrderModel.Project = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            newOrderModel.Project = event.nativeEvent.target.value;
        }
        else {
            newOrderModel.Project = '';
        }
        refreshModel(newOrderModel);
    };

    renderHeader = () => {
        const { action, newOrderModel, wareHouses, listProjects, editMode, } = this.props;
        const { _user } = this.state;
        // const projectOptions = listProjects ? listProjects.map(project => ({
        //     value: project.PrjCode,
        //     label: `${project.PrjCode} - ${project.PrjName}`
        // })) : [];

        const OnlyView = newOrderModel?.OnlyView ?? false;

        let U_FMB_WHS_TYPE = _user?.Branch?.AccountDefault?.[0]?.U_FMB_WHS_TYPE || ''; // TIPO DE SUCURSAL
        const availableWhs = _user?.Branch?.AvailableWhs || [];

        const whsOptions = wareHouses
            ? wareHouses
                .filter(whs => {
                    if ((action === 2 && !editMode) || OnlyView) return true; // En detalle mostrar el usado

                    const baseCondition =
                        whs.Inactive === 'N' // No sea inactivo
                        && whs?.U_RS_TipoAlmacen === '008'; // Solo Producto terminado
                    if (!baseCondition) return false;

                    if (Number(U_FMB_WHS_TYPE) === 3) return true; // Si es maestra no validar los almacenes configurados
                    return availableWhs?.some(a => a.WhsCode === whs.WhsCode); // Si NO es maestra validar que exista en los almacenes cofigurados
                })
                .map(whs => ({
                    value: whs.WhsCode,
                    label: `${whs.WhsCode} - ${decodeText(whs.WhsName)}`
                }))
            : [];

        return (
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo</span>
                        </div>
                        <select
                            className="form-control"
                            id='ProductionOrderType'
                            disabled={((action === 2 && !editMode) || OnlyView)}
                            value={newOrderModel.ProductionOrderType}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'ProductionOrderType')}
                        >
                            <option value={'P'}>Especial</option>
                            <option value={'S'}>Estándar</option>
                            <option value={'D'}>Desmontar</option>
                        </select>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <select
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={newOrderModel.ProductionOrderStatus}
                            onChange={(event) => this.ChangeData(event, 'ProductionOrderStatus')}
                        >
                            {(action === 1 || (action === 2 && newOrderModel?.CurrentStatus === 'P')) && <option value='P'>Planificado</option>}
                            {action === 2 && (newOrderModel?.CurrentStatus === 'P' || newOrderModel?.CurrentStatus === 'R') ?
                                <option value='R'>Liberado</option> : <></>
                            }
                            {((newOrderModel?.CurrentStatus === 'R' && !newOrderModel?.FlagCreateGoodIssue && !newOrderModel?.FlagCreateGoodsReceiptProd) || newOrderModel.CurrentStatus === 'L') &&
                                <option value='L'>Cerrado</option>
                            }
                            {newOrderModel.ProductionOrderStatus === 'C' ? <option value='C'>Cancelado</option> : <></>}


                        </select>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N° Producto</span>
                        </div>
                        <input type="text" className="form-control"
                            id="txNum"
                            autocomplete="off"
                            disabled={((action === 2 && !editMode) || OnlyView)}
                            value={newOrderModel.ItemNo}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'ItemNo')}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    !OnlyView && this.openListMaterial();
                                }
                            }}
                        />
                        {((action === 1 || editMode) && !OnlyView) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text">
                                <i className="fa fa-list" aria-hidden="true"
                                    onClick={() => this.openListMaterial()} />
                            </button>
                        )}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Descripción</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtDescr"
                            disabled={true}
                            value={newOrderModel.ItemName} />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Cantidad Planf.</span>
                                <span className="d-inline d-xl-none">Cant Planificada</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtPlannedQty"
                            disabled={((action === 2 && !editMode) || OnlyView)}
                            value={newOrderModel.PlannedQuantity}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'PlannedQuantity')}
                        />
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Nombre de</span>
                                <span className="d-inline d-xl-none">Nomb.</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtUoM"
                            disabled={true}
                            value={newOrderModel.Uom} />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Almacén</span>
                        </div>
                        {(
                            <Select
                                options={whsOptions}
                                value={whsOptions?.find(opt => opt.value === newOrderModel?.Warehouse) || null}
                                onChange={(event) => !OnlyView && this.ChangeData(event, 'WarehouseH')}
                                placeholder="Escribe para buscar un almacén"
                                isDisabled={(action === 2 && !editMode) || OnlyView}
                                isSearchable={true}
                                isClearable={true}
                                menuPortalTarget={document.body}
                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                styles={{
                                    container: (base) => ({ ...base, flex: 1 }),
                                    control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 300, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                    singleValue: (base) => ({ ...base, color: "#000" })
                                }} />
                            /*
                            <select
                                className="form-control"
                                disabled={((action === 2 && !editMode) || OnlyView)}
                                value={newOrderModel.Warehouse}
                                onChange={(event) => this.ChangeData(event, 'Warehouse')}
                            >
                                {wareHouses?.map((key, index) => {
                                    return (
                                        <option key={key.WhsCode} value={key.WhsCode}>{key.WhsName}</option>
                                    )
                                })}
                            </select>
                            */
                        )}
                    </div>
                    {action === 2 &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Cantidad a liberar</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtU_RS_CANT"
                                disabled={(action === 2 && !editMode) || newOrderModel.ProductionOrderStatus !== 'R'}
                                value={newOrderModel.U_RS_CANT}
                                onFocus={(event) => event.target.select()}
                                onChange={(e) => newOrderModel.ProductionOrderStatus === 'R' && this.changeHeaderField('U_RS_CANT', e.target.value, null, true)}
                                onBlur={(e) => newOrderModel.ProductionOrderStatus === 'R' && this.changeBlurHeaderField('U_RS_CANT', e.target.value, 4)}
                            />
                        </div>
                    }
                </div>

                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input type="text" className="form-control"
                            id="txDocNum"
                            disabled={action === 2}
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''} />
                        {(
                            <button
                                disabled={action === 2}
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={() => !OnlyView && this.openSeries()}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtSerie"
                            disabled={action === 2}
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />

                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de orden de fabr.</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            id="txtPostDate"
                            disabled={action === 2 || OnlyView}
                            value={newOrderModel.PostingDate}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'PostingDate')}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de inicio</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            id="txStartDate"
                            disabled={action === 2}
                            value={newOrderModel.StartDate}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'StartDate')} />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de finalización</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            id="txtDueDate"
                            disabled={action === 2}
                            value={newOrderModel.DueDate}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'DueDate')} />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Usuario</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtUser"
                            disabled={true}
                            value={newOrderModel?.UserSelected?.U_NAME ?? ''}
                        />
                        {/* {(action === 1 || editMode) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonRequest}>
                                <i className="fas fa-user fa-lg" aria-hidden="true" />
                            </button>
                        )} */}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Origen</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtOrigin"
                            disabled={true}
                            value={Origin[newOrderModel.ProductionOrderOrigin]} />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtCustomer"
                            disabled={true}
                            value={newOrderModel?.Client?.CardName ?? ''}
                        />
                        {((action === 1 || editMode) && !OnlyView) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPartner}>
                                <i className="fas fa-user fa-lg" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Norma de reparto</span>
                        </div>
                        <select
                            className="form-control"
                            disabled={((action === 2 && !editMode) || OnlyView)}
                        >
                            <option value='0'>Definir Nuevo</option>
                        </select>
                    </div> */}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Proyecto</span>
                        </div>
                        <Select
                            options={projectOptions}
                            value={projectOptions.find(opt => opt.value === newOrderModel.Project) || null}
                            onChange={this.ChangeProject}
                            placeholder="Escribe para buscar un proyecto"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        /> */}
                    {/* {(
                            <select
                                className="form-control"
                                disabled={((action === 2 && !editMode) || OnlyView)}
                                value={newOrderModel.Project}
                                onChange={(event) => !OnlyView && this.ChangeData(event, 'Project')}
                            >
                                <option key={'--'} value={null}>- Ninguno -</option>
                                {listProjects?.map((key, index) => {
                                    return (
                                        <option key={key.PrjCode} value={key.PrjCode}>{key.PrjCode}- {key.PrjName}</option>
                                    )
                                })}
                            </select>
                        )} */}
                    {/* </div> */}
                </div>
            </div>
        );
    }

    ChangeListMaterials = (key, value, index) => {
        const { newOrderModel, refreshModel } = this.props
        let error = false
        let maxlength
        switch (key) {
            case 'Quantity':
                maxlength = 19;
                break;
            case 'PriceList':
                maxlength = 6
                break;
            case 'Price':
                maxlength = 19
                break;
            default:
                maxlength = 20
                break;
        }
        if (key === 'Quantity' || key === 'PriceList' || key === 'Price') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value) || value.length > maxlength) {
                error = true
                return;
            }
            value = Number(value)
        }
        if (key === 'PlannedQuantity') {
            newOrderModel.ProductionOrderLines[index].BaseQuantity = value / (newOrderModel.PlannedQuantity || 1)
        }
        if (key === 'BaseQuantity') {
            newOrderModel.ProductionOrderLines[index].PlannedQuantity = value * (newOrderModel.PlannedQuantity || 1)
        }
        if (!error) {
            if (!newOrderModel.ProductionOrderLines[index].IsNew) {
                newOrderModel.ProductionOrderLines[index].IsEdit = true
            }
            newOrderModel.ProductionOrderLines[index][key] = value

            refreshModel(newOrderModel)
        }
    }

    DeleteItem = (index) => {
        const { newOrderModel, refreshModel } = this.props;
        const ProductionOrderLines = newOrderModel.ProductionOrderLines.slice();
        if (!ProductionOrderLines[index]) return;
        ProductionOrderLines.splice(index, 1);
        const auxModel = Object.assign({}, newOrderModel);
        auxModel.ProductionOrderLines = ProductionOrderLines;
        refreshModel(auxModel);
    }

    ChangeWareHouse = async (event, index) => {
        const { newOrderModel, refreshModel, showAlert, wareHouses = [], enableSpinner } = this.props;
        let value = null
        if (event && event.value !== undefined) {
            value = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        else {
            value = '';
        }
        newOrderModel.ProductionOrderLines[index]['Warehouse'] = value || null;
        //#region DIMENSIONS
        const { ItemType = 0, ItemNo = '', ItemName = '' } = newOrderModel?.ProductionOrderLines?.[index] ?? {};
        let warehouse = wareHouses?.find(whs => whs.WhsCode === value) ?? {};
        if (Modules.CostCenter && (Number(ItemType ?? 4) === 4 || Number(ItemType ?? 4) === 290) && ItemNo) { // Para artículos y recursos
            const typeL = Number(ItemType ?? 4) === 4 ? 'artículo' : 'recurso';
            if (value) { // Existe almacén
                newOrderModel.ProductionOrderLines[index].OcrCode2 = warehouse?.U_LLG_DIME2 || ''; // Determinado desde el almacén
                newOrderModel.ProductionOrderLines[index].OcrCode3 = warehouse?.U_LLG_DIME3 || ''; // Determinado desde el almacén

                newOrderModel.ProductionOrderLines[index].Dimension2 = newOrderModel.ProductionOrderLines[index].OcrCode2 ? true : false;
                newOrderModel.ProductionOrderLines[index].Dimension3 = newOrderModel.ProductionOrderLines[index].OcrCode3 ? true : false;
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" del ${typeL} ${ItemNo || ItemName} ha sido ajustado al cambiar de almacén`, timeOut: 5000 });
            } else {
                newOrderModel.ProductionOrderLines[index].OcrCode2 = null;
                newOrderModel.ProductionOrderLines[index].OcrCode3 = null;
            }
        }
        //#endregion DIMENSIONS
        newOrderModel.ProductionOrderLines[index].OnHand = null
        if ((value ?? '').trim() != '' && Number(ItemType ?? 4) == 4) {//UPDATE ON HAND
            const currItem = newOrderModel.ProductionOrderLines[index]
            const currList = currItem?.ListOnHand ?? []
            const findWhs = currList?.find(whs => whs.WhsCode == value) ?? null
            if (findWhs) {
                newOrderModel.ProductionOrderLines[index].OnHand = findWhs.OnHand
            } else {
                const searchData = {
                    ItemCode: currItem.ItemNo,
                    WhsCode: value,
                }
                enableSpinner(true)
                let response = await apiClient.SearchStockByItem(searchData);
                enableSpinner(false)
                const respData = response?.data?.[0] ?? { WhsCode: value, OnHand: null }
                newOrderModel.ProductionOrderLines[index].OnHand = respData?.OnHand ?? 0;
                if (currList.length > 0) {
                    newOrderModel.ProductionOrderLines[index].ListOnHand.push(respData)
                } else {
                    newOrderModel.ProductionOrderLines[index].ListOnHand = [respData]
                }
            }

        }

        if (whsBlocked.includes(warehouse?.U_RS_TipoAlmacen ?? null)) {
            const baseQty = newOrderModel?.ProductionOrderLines?.[index]?.BaseQuantityCopy ?? 0
            newOrderModel.ProductionOrderLines[index].BaseQuantity = baseQty
            newOrderModel.ProductionOrderLines[index].PlannedQuantity = (newOrderModel?.PlannedQuantity ?? 0) * baseQty
        }
        refreshModel(newOrderModel);
    };

    renderBody = () => {
        const { newOrderModel, action, wareHouses, editMode, openCentroCoste } = this.props;
        const { _user } = this.state;
        const OnlyView = newOrderModel?.OnlyView ?? false;
        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataResumeOrderDocument"
                            role="tab"
                            aria-controls="dataResumeOrderDocument"
                            aria-selected="false">
                            Resumen
                        </a>
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#relatedDocuments"
                            role="tab"
                            aria-controls="relatedDocuments"
                            aria-selected="false">
                            Doc. Relacionados
                        </a> */}
                    </div>

                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    {/* CONTENIDO */}
                    <div
                        className="w-100 pt-2 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 1500 }}>
                        <div className="table-responsive">
                            <table id="dataTableDocuments" className="w-100">
                                <thead className="table-header-yellow">
                                    <tr style={{ textAlign: "center" }}>
                                        <td className="sticky-column sticky-header" style={{ width: 40, background: "#d2ab24" }}> # </td>
                                        {headersBody.map((header, index) => <td key={index} className="sticky-header" style={{ ...header.style, background: "#d2ab24" }}> {header.title} </td>)}
                                    </tr>
                                </thead>

                                <tbody>
                                    {newOrderModel.ProductionOrderLines.map((item, index) => {
                                        const allowedTypes =
                                            (Number(item?.ItemType ?? 4) === 4 || Number(item?.ItemType ?? 4) === 290) ?
                                                [
                                                    '003', // CILINDROS
                                                    '004', // INSUMOS
                                                    '099', // GLP
                                                    '008', // PT
                                                ]
                                                : null;

                                        const U_FMB_WHS_TYPE = Number(_user?.Branch?.AccountDefault?.[0]?.U_FMB_WHS_TYPE ?? 0);
                                        const availableWhs = _user?.Branch?.AvailableWhs ?? [];
                                        const headerWhs = String(newOrderModel?.Warehouse ?? '');

                                        const whsOptions = wareHouses
                                            ?.filter(whs => {
                                                if ((action === 2 && !editMode) || OnlyView) return true; // En detalle sin editar mostrar el usado o en detalle edicion que ya no es planificado

                                                const baseCondition =
                                                    whs.Inactive === 'N' &&
                                                    (
                                                        !allowedTypes ||
                                                        allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '')
                                                    );

                                                if (!baseCondition) return false;

                                                if (U_FMB_WHS_TYPE === 3) { // Si es maestra no validar en los almacenes configurados
                                                } else { // Si NO es maestra validar que exista en los almacenes configurados
                                                    if (!availableWhs?.some(a => a.WhsCode === whs.WhsCode)) return false;
                                                }

                                                // Validar que coincida con el almacén seleccionado en cabecera
                                                const whsCode = String(whs?.WhsCode ?? '');

                                                const first3Match = headerWhs?.substring(0, 3) === whsCode?.substring(0, 3);
                                                const first2Match = headerWhs?.substring(0, 2) === whsCode?.substring(0, 2);

                                                return first3Match || first2Match;
                                            })
                                            ?.map(whs => ({
                                                value: whs.WhsCode,
                                                label: `${whs.WhsCode} - ${decodeText(whs.WhsName)}`,
                                                U_LLG_DIME2: whs?.U_LLG_DIME2 ?? '',
                                                U_LLG_DIME3: whs?.U_LLG_DIME3 ?? '',
                                                U_RS_TipoAlmacen: whs?.U_RS_TipoAlmacen ?? null
                                            })) || [];

                                        const whsSelected = whsOptions?.find(opt => opt.value === item.Warehouse)
                                        if (Number(item?.ItemType ?? 4) === -18) {
                                            return (
                                                <tr
                                                    key={item.LineNumber ?? `new-${index}-${item.ItemNo}`}
                                                    style={{
                                                        maxHeight: 10,
                                                        paddingTop: 8,
                                                        paddingBottom: 8,
                                                    }}
                                                    data-toggle={'tooltip'}
                                                >
                                                    <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                                                        {index + 1}
                                                    </td>
                                                    <td style={{ minWidth: '150px' }} >
                                                        <select
                                                            disabled={true}
                                                            id={`ItemType-${index}`}
                                                            className="form-control"
                                                            value={item.ItemType}
                                                        // onChange={(event) => this.ChangeListMaterials('ItemType', event.nativeEvent.target.value, index)}
                                                        >
                                                            <option value='4'>Artículo</option>
                                                            <option value='290'>Recurso</option>
                                                            <option value='-18'>Texto</option>
                                                        </select>
                                                    </td>
                                                    <td colSpan={(headersBody.length - 2) || 1}>
                                                        <input
                                                            style={{ minWidth: '100px' }}
                                                            disabled={((action === 2 && !editMode) || OnlyView)}
                                                            value={item.LineText}
                                                            id={`LineText-${index}`}
                                                            className="form-control"
                                                            type="text"
                                                            onChange={(event) => !OnlyView && this.ChangeListMaterials('LineText', event.nativeEvent.target.value, index)}
                                                        />
                                                    </td>
                                                    <td
                                                        className="sticky-columns"
                                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                        {/*Eliminar*/}
                                                        {(!(action === 2 && !editMode) && !OnlyView) && (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    padding: 5,
                                                                    color: '#c42222',
                                                                }}
                                                                className="btn"
                                                                onClick={() => this.DeleteItem(index)}>
                                                                <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        } else {
                                            return (
                                                <tr
                                                key={item.LineNumber ?? `new-${index}-${item.ItemNo}`}
                                                    style={{
                                                        maxHeight: 10,
                                                        paddingTop: 8,
                                                        paddingBottom: 8
                                                    }}
                                                    data-toggle="tooltip" >

                                                    <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                                                        {index + 1}
                                                    </td>
                                                    <td style={{ minWidth: '150px' }} >
                                                        <select
                                                            disabled={true}
                                                            id={`ItemType-${index}`}
                                                            className="form-control"
                                                            value={item.ItemType}
                                                        // onChange={(event) => this.ChangeListMaterials('ItemType', event.nativeEvent.target.value, index)}
                                                        >
                                                            <option value='4'>Artículo</option>
                                                            <option value='290'>Recurso</option>
                                                            <option value='-18'>Texto</option>
                                                        </select>
                                                    </td>
                                                    {/*Artículos*/}
                                                    <td className="overflow-visible" style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                        {item.ItemNo}
                                                    </td>
                                                    {/* DESCRIPCION */}
                                                    <td className="overflow-visible" style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                        {item.ItemName}
                                                    </td>
                                                    {/* CANTIDAD BASE */}
                                                    <td>
                                                        <input
                                                            style={{ minWidth: '100px' }}
                                                            disabled={((action === 2 && !editMode) || (item?.isStatic === 'Y') || whsBlocked.includes(whsSelected?.U_RS_TipoAlmacen ?? null))}
                                                            value={item.BaseQuantity}
                                                            id={`prodItmBaseQuantity-${index}`}
                                                            className="form-control"
                                                            type="text"
                                                            onChange={(event) => {
                                                                const value = event.nativeEvent.target.value;
                                                                if (!/^\d*\.?\d*$/.test(value)) return;
                                                                !OnlyView && item?.isStatic !== 'Y' && this.ChangeListMaterials('BaseQuantity', event.nativeEvent.target.value, index);
                                                            }}/>
                                                    </td>
                                                    {/* CTD. REQUERIDA */}
                                                    <td>
                                                        <input
                                                            style={{ minWidth: '100px' }}
                                                            disabled={((action === 2 && !editMode) || OnlyView || whsBlocked.includes(whsSelected?.U_RS_TipoAlmacen ?? null))}
                                                            value={item.PlannedQuantity}
                                                            id={`prodItmPlannedQuantity-${index}`}
                                                            className="form-control"
                                                            type="text"
                                                            onChange={(event) => {
                                                                const value = event.nativeEvent.target.value;
                                                                if (!/^\d*\.?\d*$/.test(value)) return;
                                                                !OnlyView && this.ChangeListMaterials('PlannedQuantity', event.nativeEvent.target.value, index);
                                                            }}/>
                                                    </td>
                                                    {/* CONSUMIDO */}
                                                    <td>{item.IssuedQuantity ? formatNumber(item.IssuedQuantity ?? 0) : 0}</td>
                                                    {/* <td>
                                                    <input
                                                        style={{ minWidth: '100px' }}
                                                        disabled={true}
                                                        value={item.Available ?? 0}
                                                        id={`prodItmAvailable-${index}`}
                                                        className="form-control"
                                                        type="text" />
                                                </td> */}
                                                    {/* STOCK EN ALM. */}
                                                    <td>
                                                        <input
                                                            style={{ minWidth: '100px' }}
                                                            disabled={true}
                                                            value={item.Warehouse ? formatNumber(item.OnHand ?? 0) : ''}
                                                            id={`onHandItm-${index}`}
                                                            className="form-control"
                                                            type="text" />
                                                    </td>
                                                    {/* <td>{item?.UoMCode || ''}</td> */}
                                                    {/* NOM. UNIDAD DE MEDIDA */}
                                                    <td>{item.Uom}</td>
                                                    {/* ALMACEN */}
                                                    <td>
                                                        <Select
                                                            options={whsOptions}
                                                            value={whsOptions?.find(opt => opt.value === item.Warehouse) || null}
                                                            onChange={(e) => !OnlyView && this.ChangeWareHouse(e, index)}
                                                            placeholder="Escribe para buscar un almacén"
                                                            isDisabled={((action === 2 && !editMode) || OnlyView)}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                            styles={{
                                                                container: (base) => ({ ...base, flex: 1 }),
                                                                control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: action === 2 && !editMode ? 575 : 610, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                                singleValue: (base) => ({ ...base, color: "#000" })
                                                            }} />
                                                        {/* <select
                                                        style={{ minWidth: '250px' }}
                                                        disabled={((action === 2 && !editMode) || OnlyView)}
                                                        id='ItemWHS'
                                                        className="form-control"
                                                        value={item.Warehouse}
                                                        onChange={(event) => !OnlyView && this.ChangeListMaterials('Warehouse', event.nativeEvent.target.value, index)}
                                                    >
                                                        
                                                            {wareHouses?.map((wareHouse, index) => {
                                                                return (
                                                                    <option key={'WareHouseBody' + index} value={wareHouse.WhsCode}>{wareHouse.WhsName}</option>
                                                                )
                                                            })}
                                                    </select> */}
                                                    </td>
                                                    <td className="sticky-column">
                                                        <select
                                                            disabled={((action === 2 && !editMode) || OnlyView)}
                                                            id={`ItemEmision-${index}`}
                                                            className="form-control"
                                                            value={item.ProductionOrderIssueType}
                                                            onChange={(event) => !OnlyView && this.ChangeListMaterials('ProductionOrderIssueType', event.nativeEvent.target.value, index)}>
                                                            <option value='im_Manual'>Manual</option>
                                                            <option value='im_Backflush'>Notificación</option>
                                                        </select>
                                                    </td>
                                                    {/* <td></td>
                                                <td></td> */}
                                                    {Modules.CostCenter && <>
                                                        <td style={{ minWidth: 150 }}>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    id={`dimension1-${index}`}
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode || ""} />

                                                                {((action === 1 || (action === 2 && editMode)) && !item.Dimension1 && !OnlyView) && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => openCentroCoste(index, 1)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ minWidth: 150 }}>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    id={`dimension2-${index}`}
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode2 || ""} />

                                                                {((action === 1 || (action === 2 && editMode)) && !item.Dimension2 && !OnlyView) && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => openCentroCoste(index, 2)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ minWidth: 150 }}>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    id={`dimension3-${index}`}
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode3 || ""} />

                                                                {((action === 1 || (action === 2 && editMode)) && !item.Dimension3 && !OnlyView) && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => openCentroCoste(index, 3)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ minWidth: 150 }}>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    id={`dimension4-${index}`}
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode4 || ""} />

                                                                {((action === 1 || (action === 2 && editMode)) && !item.Dimension4 && !OnlyView) && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => openCentroCoste(index, 4)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ minWidth: 150 }}>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    id={`dimension5-${index}`}
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode5 || ""} />

                                                                {((action === 1 || (action === 2 && editMode)) && !item.Dimension5 && !OnlyView) && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => openCentroCoste(index, 5)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </>}
                                                    <td
                                                        className="sticky-columns"
                                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                        {/*Eliminar*/}
                                                        {((action === 1 || editMode) && !OnlyView && !whsBlocked.includes(whsSelected?.U_RS_TipoAlmacen ?? null)) && (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    padding: 5,
                                                                    color: '#c42222',
                                                                }}
                                                                className="btn"
                                                                onClick={() => this.DeleteItem(index)}>
                                                                <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                                    }
                                    <tr style={{
                                        maxHeight: 10,
                                        paddingTop: 8,
                                        paddingBottom: 8,
                                    }}>
                                        <td />
                                        <td className="sticky-column"
                                            style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                            {(action === 1 || editMode) && newOrderModel.ItemNo && !OnlyView && (
                                                <div>

                                                    <select
                                                        id='ItemTypeSearch'
                                                        className="form-control"
                                                        value={newOrderModel?.ItemTypeSearch ?? '4'}
                                                        onChange={(event) => this.ChangeData(event, 'ItemTypeSearch')}
                                                    >
                                                        <option value='4'>Artículo</option>
                                                        <option value='290'>Recurso</option>
                                                        <option value='-18'>Texto</option>
                                                    </select>

                                                    <input
                                                        id='InputSearchItmsMaterial'
                                                        type=" text"
                                                        placeholder={placeholderSearch[newOrderModel?.ItemTypeSearch ?? '4']}
                                                        className=" form-control btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            minWidth: '130px',
                                                        }}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.openItems('lines');
                                                            }
                                                        }}
                                                        value={newOrderModel.searchItemMaterial || ''}
                                                        onChange={event => this.changeSearchItem(event)}
                                                    />
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: 'green',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openItems('lines')}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* RESUMEN */}
                    <div
                        className="w-100 tab-pane fade"
                        id="dataResumeOrderDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }} >
                        {this.renderCostos()}
                        <div className="row">
                            {this.renderCantidades()}
                            {this.renderFechas()}
                            {this.renderTiemposPlanificados()}
                        </div>
                    </div>
                    {/*_________________END RESUMEN_________________________________________ */}
                    {/* DOCUMENTOS RELACIONADOS */}
                    <div
                        className="w-100 tab-pane fade"
                        id="relatedDocuments"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5, paddingLeft: '1%' }}
                    >
                        {newOrderModel.RelatedDocs.map((doc, index) => (
                            <>
                                <div className="row" key={index} style={{ marginBottom: '10px' }}>
                                    {doc.DocNumEmit != null ?
                                        <div className="col d-flex align-items-start" style={{ marginLeft: '1%' }}>
                                            <div><strong>Doc. Emisión: </strong> {doc.DocNumEmit}</div>
                                            <div style={{ marginLeft: '10px' }}><strong>Fecha: </strong> {doc.DocDateEmit != null ? moment(doc.DocDateEmit).format('DD-MM-YYYY') : ''}</div>
                                        </div> : <></>}
                                    {doc.DocNumRecipt != null ?
                                        <div className="col d-flex align-items-start" style={{ borderLeft: '1px', paddingLeft: '10px' }}>
                                            <div><strong>Doc. Recepción: </strong> {doc.DocNumRecipt}</div>
                                            <div style={{ marginLeft: '10px' }}><strong>Fecha: </strong> {doc.DocDateRecipt != null ? moment(doc.DocDateRecipt).format('DD-MM-YYYY') : ''}</div>
                                        </div> : <></>}
                                </div>
                            </>
                        ))}
                    </div>
                    {/*_________________END DOCUMENTOS RELACIONADOS _________________ */}

                </div>
            </div>
        );
    }

    renderCostos = () => {
        const { newOrderModel, action } = this.props;
        const { _user } = this.state;
        if (!_user?.BranchPermission?.ProductionPrices) {
            return (<></>)
        }
        return (
            <>
                <div className="h4 my-3">Costos</div>
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Costo de componente de artículo real</span>
                                    <span className="d-inline d-xl-none">Costo Comp Artículo</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.CostoComponenteArticuloReal || ''}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Costo de componente de recurso real</span>
                                    <span className="d-inline d-xl-none">Costo Comp Recurso</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.CostoComponenteRecursoReal}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Costo adicional real</span>
                                    <span className="d-inline d-xl-none">Costo Adicional</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.CostoAdicionalReal}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Costo de producto real</span>
                                    <span className="d-inline d-xl-none">Costo Producto</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.CostoComponenteArticuloReal || ''}
                            />
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Coste real de subproductos</span>
                                    <span className="d-inline d-xl-none">Costo Subproductos</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.CosteRealSubproductos}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Desviación total</span>
                                    <span className="d-inline d-xl-none">Desviación</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.DesviacionTotal}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Asiento contable</span>
                                    <span className="d-inline d-xl-none">Asiento</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2}
                                value={newOrderModel.JournalRemarks}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    renderCantidades = () => {
        const { newOrderModel, action } = this.props
        return (
            <div className="col-12 col-lg-6 col-xl-4">
                <div className="h4 my-3">Cantidades</div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">
                            <span className="d-none d-xl-inline">Cantidad planificada</span>
                            <span className="d-inline d-xl-none">Cant Planificada</span>
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2}
                        value={newOrderModel.PlannedQuantity}
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">
                            <span className="d-none d-xl-inline">Cantidad completada</span>
                            <span className="d-inline d-xl-none">Cant Completada</span>
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2}
                        value={newOrderModel.CompletedQuantity}
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">
                            <span className="d-none d-xl-inline">Cantidad rechazada</span>
                            <span className="d-inline d-xl-none">Cant Rechazada</span>
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2}
                        value={newOrderModel.RejectedQuantity}
                    />
                </div>
            </div>
        )
    }

    renderFechas = () => {
        const { newOrderModel, action } = this.props
        return (
            <div className="col-12 col-lg-6 col-xl-4">
                <div className="h4 my-3">Fechas</div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">F. finalización</span>
                    </div>
                    <input
                        type="date"
                        className="form-control"
                        disabled={action === 2}
                        value={newOrderModel.DueDate}
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">F. cierre real</span>
                    </div>

                    <input
                        type={"date"}
                        className="form-control"
                        disabled={action === 2}
                        value={newOrderModel.ClosingDate}
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">Vencido</span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2}
                        value={newOrderModel.Vencido || ''}
                    />
                </div>
            </div>
        )
    }

    renderTiemposPlanificados = () => {
        const { newOrderModel, action } = this.props;
        const OnlyView = newOrderModel?.OnlyView ?? false;
        return (
            <div className="col-12 col-xl-4">
                <div className="h4 my-3">Tiempos planificados</div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">
                            <span className="d-none d-xl-inline">Tiempo de ejecución total</span>
                            <span className="d-inline d-xl-none">Tiempo Ejecución</span>
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2 || OnlyView}
                        value={newOrderModel.TiempoEjecucionTotal}
                        onChange={(event) => !OnlyView && this.ChangeData(event, 'TiempoEjecucionTotal')}
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">
                            <span className="d-none d-xl-inline">Tiempo adicional total</span>
                            <span className="d-inline d-xl-none">Tiempo Adicional</span>
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2 || OnlyView}
                        value={newOrderModel.TiempoAdicionalTotal}
                        onChange={(event) => !OnlyView && this.ChangeData(event, 'TiempoAdicionalTotal')}
                    />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold">Tiempo total</span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={action === 2 || OnlyView}
                        value={newOrderModel.TiempoTotal}
                        onChange={(event) => !OnlyView && this.ChangeData(event, 'TiempoTotal')}
                    />
                </div>
            </div>
        )
    }

    renderFooter = () => {
        const { action, newOrderModel, editMode } = this.props;
        const OnlyView = newOrderModel?.OnlyView ?? false;
        return (
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={((action === 2 && !editMode) || OnlyView)}
                            value={newOrderModel.Remarks}
                            onChange={(event) => !OnlyView && this.ChangeData(event, 'Remarks')}
                        />
                    </div>
                </div>
                {/* <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Observaciones de empaque</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action === 2}
                            value={newOrderModel.PickRmrk}
                            onChange={(event) => this.ChangeData(event, 'PickRmrk')}
                        />
                    </div>
                </div> */}
            </div>
        );
    }

    render() {
        const { render } = this.props;
        let content = '';
        switch (render) {
            case 'header':
                content = this.renderHeader();
                break;
            case 'body':
                content = this.renderBody();
                break;
            case 'footer':
                content = this.renderFooter();
                break;
            default:
                content = '';
        }

        return (
            <div className='Content'>
                {content}
            </div>
        );
    }
}

export default ContentProductionOrder;